import { getIn } from 'formik';
import { get } from 'lodash';
import { deepGetFirstNumberOrString } from '../../Shared/ObjectUtilities';
export function getErrorText(form, name, force) {
    if (force === void 0) { force = false; }
    if (!force) {
        var touch = getIn(form.touched, name, false);
        if (!touch)
            return '';
    }
    var error = getIn(form.errors, name, '');
    var errorText = deepGetFirstNumberOrString(error).toString();
    return !!errorText ? errorText : '';
}
export function getErrorIfTouched(path, errors, touchedFields) {
    var error = get(errors, path, '');
    var fieldTouched = touchedFields ? get(touchedFields, path, false) : true;
    return fieldTouched ? error : '';
}
// Expects to return 0-1 error strings for each item in the array or first level property if object
export function getErrorIfTouchedFromObject(path, errors, touchedFields) {
    var errorItem = get(errors, path, '');
    if (!errorItem)
        return [];
    if (typeof errorItem !== 'object') {
        // String, just return the error
        var errorIfTouched = getErrorIfTouched(path, errors, touchedFields);
        if (!!errorIfTouched)
            return [errorIfTouched];
    }
    else if (!Array.isArray(errorItem)) {
        // Object, return 1 error for each property with a error.
        var newErrors = [];
        for (var errorItemKey in errorItem) {
            if (errorItem.hasOwnProperty(errorItemKey)) {
                // Create the property sub path
                var subItemPath = path + "." + errorItemKey;
                var subItemError = getErrorIfTouchedFromObject(subItemPath, errors, touchedFields);
                // If it's a sub-array || sub-object, only return the first error. Not all of them.
                // If the user cared about all of them, they will ask at that lower level
                if (subItemError.length > 0)
                    newErrors.push(subItemError[0]);
            }
        }
        if (newErrors.length > 0)
            return newErrors;
    }
    else {
        // Array, loop through each item and return a error if it has one.
        return errorItem
            .map(function (it, index) {
            var errorItemPath = path + "[" + index + "]";
            var subErrors = getErrorIfTouchedFromObject(errorItemPath, errors, touchedFields);
            return subErrors.length > 0 ? subErrors[0] : '';
        })
            .filter(function (it) { return !!it; });
    }
    return [];
}
